import _ from 'underscore';

function MergeAttributionsTableCtrl($scope) {
  if (!$scope.attributions || !_.isArray($scope.attributions)) throw new Error('merge-attributions-table directive - attributions is required on scope');

  _initScope();

  function _initScope() {
    $scope.selectedProperties = $scope.selectedProperties || {};

    if ($scope.attributions && $scope.attributions.length) {
      const props = _.pick($scope.attributions[0], ['id', 'name']);
      _.extend($scope.selectedProperties, props);
    }

    $scope.selectAttribution = function (attribution, $event) {
      if (!attribution) return;
      if ($event) $event.preventDefault();

      $scope.selectedProperties.id = attribution.id;
    };
  }
}

MergeAttributionsTableCtrl.$inject = [
  '$scope'
];

export default MergeAttributionsTableCtrl;



// WEBPACK FOOTER //
// ./src/directives/mergeAttributionsTable/controller.js